import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { PRODUCT } from "../mock";

const CartContext = createContext(null);

const STORAGE_KEY = "flowlux_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addToCart = (bundle, openDrawer = true) => {
    // Single-bundle cart: selecting a bundle replaces the cart with exactly that option.
    setItems([
      {
        id: `bundle-${bundle.qty}`,
        title: `${PRODUCT.title.split("\u2013")[0].trim()} \u2014 ${bundle.label}`,
        price: bundle.price,
        compareAt: bundle.compareAt,
        image: PRODUCT.images[0],
        qty: 1,
        masks: bundle.qty,
        link: bundle.link,
      },
    ]);
    if (openDrawer) setIsOpen(true);
  };

  const updateQty = (id, qty) => {
    if (qty <= 0) {
      setItems((prev) => prev.filter((i) => i.id !== id));
    } else {
      setItems((prev) => prev.map((i) => (i.id === id ? { ...i, qty } : i)));
    }
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clearCart = () => setItems([]);

  const count = useMemo(() => items.reduce((s, i) => s + (i.masks || i.qty), 0), [items]);
  const subtotal = useMemo(
    () => items.reduce((s, i) => s + i.price * i.qty, 0),
    [items]
  );
  const savings = useMemo(
    () => items.reduce((s, i) => s + (i.compareAt - i.price) * i.qty, 0),
    [items]
  );

  const value = {
    items,
    isOpen,
    setIsOpen,
    addToCart,
    updateQty,
    removeItem,
    clearCart,
    count,
    subtotal,
    savings,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
};
